import { motion } from "framer-motion";

const cards = [
  {
    cls: "md:col-span-7",
    img: "/assets/van-front.jpg",
    overline: "The Vehicle",
    title: "Kia Carnival — Seven in Comfort",
    specs: "7 seats · Room for luggage · Climate control",
    testid: "fleet-card-vehicle",
  },
  {
    cls: "md:col-span-5",
    img: "/assets/driver.png",
    overline: "Your Driver",
    title: "Meet Daniel",
    specs: "Private operator · Tour guide & chauffeur · Blue Mountains local",
    testid: "fleet-card-driver",
  },
  {
    cls: "md:col-span-12",
    img: "/assets/van-dirt.webp",
    overline: "Built for the Mountains",
    title: "From Sydney motorways to Newnes Plateau fire trails",
    specs: "Airport runs · Dirt roads · Escarpment lookouts",
    position: "object-bottom",
    testid: "fleet-card-terrain",
  },
];

export default function Fleet() {
  return (
    <section
      id="fleet"
      className="py-32 max-w-7xl mx-auto px-6 lg:px-10"
      data-testid="fleet-section"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="mb-20 flex flex-wrap items-end justify-between gap-8"
      >
        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-[#d4af37] mb-6">
            Vehicle & Driver
          </p>
          <h2 className="font-serif-lux text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight max-w-2xl">
            One vehicle. One driver. No hand-offs.
          </h2>
        </div>
        <p className="max-w-sm text-base leading-relaxed tracking-wide text-[#888]">
          You ride in the same immaculate Kia Carnival every time, driven by
          Daniel — the person who answered your enquiry.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
        {cards.map((v, i) => (
          <motion.div
            key={v.testid}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: (i % 2) * 0.12 }}
            className={`group relative overflow-hidden border border-white/10 h-[420px] md:h-[520px] max-h-[80vh] ${v.cls}`}
            data-testid={v.testid}
          >
            <img
              src={v.img}
              alt={v.title}
              className={`absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1400ms] ease-out ${v.position || ""}`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 via-[#050505]/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <p className="text-[10px] tracking-[0.35em] uppercase text-[#d4af37] mb-3">
                {v.overline}
              </p>
              <h3 className="font-serif-lux text-2xl sm:text-3xl font-light tracking-tight">
                {v.title}
              </h3>
              <p className="mt-2 text-xs tracking-[0.15em] uppercase text-[#999]">
                {v.specs}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
